import React, { useContext } from "react";
import Weather from "./Weather";
import Box from "./Content";
import Forcasttime from "./Forcasttime";
import Forcastday from "./Forcastdate";
import { data } from "./Index";
import { motion } from "framer-motion";
const Weatherpage = () => {
	const boxdata1 = useContext(data);

	const { weatherData } = boxdata1;

	return (
		<>
			<div className="middlecontent">
				{weatherData?.condition1 && (
					<div className="box">
						<Weather
							currenttime={weatherData.currenttime}
							cityname={weatherData.cityName}
							citycountry={weatherData.citycountry}
							icon={weatherData.icon}
							temprature={weatherData.temprature}
							weather={weatherData.weather}
						/>
						<div className="content">
							{boxdata1.boxdata.map((data, index) => (
								<Box
									key={index}
									boximage={data.boximage}
									bgimage={data.bgimage}
									bgcolor={data.bgcolor}
									boxicon={data.boxicon}
									boxname={data?.boxname}
									boxdata={data.boxdata}
									boxdatashow={data.boxdatashow}
									textcolor={data.textcolor}
									classprops={data.class}
									boxclass={data.boxclass}
									blurfilter={data.blurfilter}
									elments={data?.elements}
								/>
							))}
						</div>
					</div>
				)}
			</div>
			{
				<div className="rightcontent">
					<div className="forcasttime">
						<h3>TODAY'S FORCAST</h3>
						{boxdata1.forcasttimedata.map((data, index) => (
							<Forcasttime
								key={index}
								date={data.date}
								weather={data.weather}
								icon={data.icon}
								max={data.max}
								min={data.min}
							/>
						))}
					</div>
					<div className="forcastday">
						<h3>5-DAY FORCAST</h3>
						{boxdata1.forcastdaydata.map((data, index) => (
							<Forcastday
								key={index}
								date={data.date}
								days={data.days}
								weather={data.weather}
								icon={data.icon}
								max={data.max}
								min={data.min}
							/>
						))}
					</div>
				</div>
			}
		</>
	);
};

export default Weatherpage;
